/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { JSONWebKey, JSONWebKey$inboundSchema } from "./jsonwebkey.js";

export type ListJSONWebKeysResult = {
  /**
   * The set's published keys.
   */
  keys: Array<JSONWebKey>;
};

/** @internal */
export const ListJSONWebKeysResult$inboundSchema: z.ZodMiniType<
  ListJSONWebKeysResult,
  unknown
> = z.object({
  keys: z.array(JSONWebKey$inboundSchema),
});

export function listJSONWebKeysResultFromJSON(
  jsonString: string,
): SafeParseResult<ListJSONWebKeysResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListJSONWebKeysResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListJSONWebKeysResult' from JSON`,
  );
}
